import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "fullNameTicket",
})
export class FullNameTicketPipe implements PipeTransform {
  transform(user: any): string {
    if (user == null || user == undefined || user == "") {
      return "";
    }

    if (user.fullName) {
      return user.fullName;
    }

    return user.firstName + " " + user.lastName;
  }
}
